/**
 * Resolve API base for axios and storage URLs.
 * Production HTTPS uses same-origin `/api` (Traefik StripPrefix) so multiple Host()
 * labels (reecoverse.com, www, vboom.io) work without cross-origin API calls.
 */
export function resolveApiBase() {
  const envUrl = (import.meta.env.VITE_API_URL || '').trim()
  if (typeof window === 'undefined') {
    return envUrl || 'http://localhost:8000'
  }

  const isHttpsPage = window.location.protocol === 'https:'
  if (isHttpsPage && envUrl.startsWith('http://')) {
    return '/api'
  }

  const isLocalHost =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

  if (!isLocalHost) {
    if (!envUrl || envUrl.startsWith('/')) {
      return '/api'
    }
    try {
      const envHost = new URL(envUrl, window.location.origin).hostname
      if (envHost !== window.location.hostname) {
        return '/api'
      }
    } catch {
      return '/api'
    }
  }

  return envUrl || 'http://localhost:8000'
}
